import { connect } from "react-redux";
import Toast from "../components/Toast/index.js";
import { sceneSlice } from "../../store/sceneSlice";
import { sessionSlice } from "../../store/sessionSlice";

const mapStateToProps = (state) => {
  return {
    display: state.session.displayToast,
    message: state.session.toastMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClose: () => {
      dispatch(sessionSlice.actions.stopDisplayingToast());
    },
  };
};

export const ToastContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Toast);
